import styled from 'styled-components'

export const TrendingBgContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: none;
`

export const NonHeaderContainer = styled.div`
  display: flex;
  height: 100%;
  overflow: auto;
  background-color: ${props => (props.darkMode ? '#0f0f0f' : '#f9f9f9')};
`
